import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
  }

  .border-secondary {
    border-color: #ced4da!important;
  }

  .text-light {
    color: #ced4da!important;
  }

  .alert {
    white-space: pre-line
  }

  .error-summary {
    color: #dc3545!important;
    background-color: #ffefef!important;
    border: 1px solid;
    border-radius: .25rem!important;
    border-color: #dc3545!important;
    margin-top: .75rem!important;
    margin-bottom: .75rem!important;
  }

  ul.dash {
    list-style: none;
    margin-left: 0;
    padding-left: 1em;
  }
  ul.dash > li:before {
      display: inline-block;
      content: "-";
      width: 1em;
  }

  a.error:link {
    color: #dc3545!important;
  }
  a.error:visited {
    color: #dc3545!important;
  }

  .trash-can--disabled {
    opacity: .5;
  }

  .border-card-active {
    border-left: 4px #007bff solid;
  }

  .border-card-error,
  .border-card-error.border-card-active {
    border-color #dc3545;
  }

  .border-input-error {
    border-left: 4px #dc3545 solid;
    padding-left: 10px;
  }

  .fit-content {
    width: fit-content;
  }

  .width-inherit {
    width: inherit;
  }

  .taxi-checkbox {
    transition: none;
    flex-basis: 0;
    align-self: flex-start;
    font-size: 1rem;
  }

  *:has(.taxi-checkbox.is-invalid) + .invalid-feedback {
    display: block;
  }

  .fill-branching-gray {
    fill: #adadad;
  }

  .fill-branching-green {
    fill: #127d53;
  }

  .fill-thank-you-transparent {
    fill: transparent;
  }

  .fill-white {
    fill: #ffffff;
  }

  .branch-follow-editor {
    border-radius: 4px;
    border: 1px solid #cbe3d6;
    font-size: 0.9286rem;
    padding: 20px 24px 0;
  }

  .bg-branching-green {
    background: #eaf5ed;
  }

  .code {
    border-radius: 4px;
    background: #f7f7f7;
    border: 1px solid #cccccc;
    color: #c12e2a;
    font-family: "Andale Mono", monospace;
    padding: 4px;
    font-size: 0.8571rem
  }
  .card-header .branch-member {
    color: #127d53;
  }

  .h5 {
    font-size: 1.125rem;
  }

  .close {
    line-height: 0.5;
  }

  .field-inserters {
    opacity: 0;
    padding: .5rem;
    z-index: 0;
    max-height: 1rem;
    transition: opacity .4s, padding .4s;
  }

  .field-inserters.show {
    opacity: 1;
    padding 1rem 0;
    max-height: initial;
  }

  .field-inserters > button {
    background: var(--light);
    visibility: hidden;
  }
  .field-inserters.show > button {
    visibility: visible;
  }
  .field-inserters::after {
    position: absolute;
    content: "";
    border-top: 2px dashed #ced4da;
    width: 100%;
    top: 50%;
    z-index: -1;
  }

  .modal-backdrop {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1020;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.5);
  }
  .minimized-field {
    z-index: 0;
    opacity: .35;
  }
  .minimized-field::before {
    content: "";
    position: absolute;
    top: 50%;
    border-top: 1px solid;
    width: 100%;
    z-index: -1;
  }
  .nav .nav-link {
    color: inherit;
    text-decoration: none;
  }
  .nav .nav-item .nav-link.active {
    color: #007bff;
    border-bottom: 3px solid #007bff;
  }

  .nav .nav-item .nav-link:hover {
    color: #007bff;
    border-bottom: 3px solid #007bff;
  }

`;
